import { render, staticRenderFns } from "./Load.vue?vue&type=template&id=71ea0742"
import script from "./Load.vue?vue&type=script&lang=js"
export * from "./Load.vue?vue&type=script&lang=js"
import style0 from "./Load.vue?vue&type=style&index=0&id=71ea0742&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3254644805/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71ea0742')) {
      api.createRecord('71ea0742', component.options)
    } else {
      api.reload('71ea0742', component.options)
    }
    module.hot.accept("./Load.vue?vue&type=template&id=71ea0742", function () {
      api.rerender('71ea0742', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Loads/Load.vue"
export default component.exports